import {PlainLink} from 'core/components/link'
import {IFormFields, Login, loginFormFactory} from 'core/components/login'
import {routeProps} from 'core/utils/react-router-helpers'
import * as React from 'react'
import {connect, Dispatch} from 'react-redux'
import {Redirect, RouteComponentProps, withRouter} from 'react-router'
import Card from 'study_reviewer/components/Card'
import * as routes from 'study_reviewer/routes'
import {IState, loginRequest} from 'study_reviewer/store'
import * as styles from './LoginPage.css'

interface IStateProps {
  isLoggedIn: boolean
}
interface IDispatchProps {
}
interface IOwnProps extends RouteComponentProps<void> {}
interface IProps extends IStateProps, IDispatchProps, IOwnProps {}

const LOGIN_FORM_NAME = 'login'
const onSubmit = (data: IFormFields, dispatch: Dispatch<void>) => {
  dispatch(loginRequest(data, LOGIN_FORM_NAME))
}
const LoginForm = loginFormFactory({formName: LOGIN_FORM_NAME, onSubmit})

class LoginPage extends React.Component<IProps, {}> {
  public render() {
    const {isLoggedIn} = this.props
    if (isLoggedIn) return this.redirectToReferrer()

    return (
      <div className={styles.page}>
        <Card>
          <Login
            {...routeProps<IProps, void>(this.props)}
            renderForm={() => <LoginForm theme={{error: styles.error}} />}
            theme={{graphic: styles.graphic, lettering: styles.lettering}}
          />
          <PlainLink className={styles.forgotPasswordLink} to={routes.forgotPasswordRoute()}><u>Forgot Password?</u></PlainLink>
        </Card>
        <Card>
          <PlainLink className={styles.link} to={routes.registerRoute()}>
            Need an account? <u>Register for Physician Access</u>
          </PlainLink>
        </Card>
      </div>
    )
  }

  private redirectToReferrer() {
    const from = this.props.location.state && this.props.location.state.from
    if (!from || from.pathname === routes.loginRoute() || from.pathname === routes.logoutRoute()) {
      return <Redirect to={routes.rootRoute()} />
    }
    return <Redirect to={from} />
  }
}

const mapStateToProps = (state: IState): IStateProps => ({
  isLoggedIn: !!state.login.token,
})

export default withRouter(
  connect<IStateProps, IDispatchProps, IOwnProps, IState>(mapStateToProps)(LoginPage),
)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/pages/LoginPage.tsx